import { render, staticRenderFns } from "./NavbarDynamicValue.vue?vue&type=template&id=1df6065a&"
import script from "./NavbarDynamicValue.vue?vue&type=script&lang=js&"
export * from "./NavbarDynamicValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports